<template>
<div :class="{'webLogo':true, 'webLogo-hidden':isHiddenLogo}" v-if="this.$parent.isorder">

	<div class='wl-model max-width'>
		<div class='wl-model-logo' v-if="this.$parent.isorder">
			<img class='wl-model-logo-img' src='@/assets/c-logo.png' />
		</div>
		<div class='wl-model-circle'>
			<template v-for='item in htp_list'>
				<div :key='item.id' class='wl-model-circle-view'>
					<div class='wl-model-circle-vi-icon'>
						<img class='wl-model-circle-vi-ic-img' :src='item.icon' />
					</div>
					<div class='wl-model-circle-vi-font'>
						<div class='wl-model-circle-vi-fo-name font-16 fontweight-bo'>{{item.name}}</div>
						<div class='wl-model-circle-vi-fo-prompt font-12'>{{item.font}}</div>
					</div>
				</div>
			</template>
		</div>
		<div class='wl-model-banner' @click='func_qq'  v-if="this.$parent.isorder" >
			<img class='wl-model-banner-img' src='@/assets/banner/logo-banner.png' />
		</div>
	</div>

</div>
</template>
<script>
import htp01 from '@/assets/banner/htp_shouhou.png';
import htp02 from '@/assets/banner/htp_fuwu.png';
import htp03 from '@/assets/banner/htp_pinzhi.png';

export default {
	name: 'webTop',
	props: {
		isHiddenLogo: {
			type: Boolean,
			default: false,
		}
	},
	data() {
		return {
			htp_list: [
				{
					icon: htp03,
					name: '品质保证',
					font: '顶尖设备 创新工艺',
				},
				{
					icon: htp02,
					name: '用心服务',
					font: '专人客服 及时响应',
				},
				{
					icon: htp01,
					name: '售后无忧',
					font: '质量问题 免费重印',
				},
			]
		}
	},
	methods: {
		func_qq() {
			window.open('tencent://message/?uin=800180939');
		}
	}
}
</script>
<style scoped>
@media only screen and (min-width: 480px) {
.webLogo {
	background:#ffffff;
	width:100%; height:140px;
	display:flex; justify-content:center; align-items:flex-end;
	box-sizing:border-box; padding-bottom:24px;
	overflow:hidden;
}
.webLogo-hidden {
	height:0;
	padding-bottom:0;
}
.wl-model {
	display:inline-flex; justify-content:space-between; align-items:center;
}
.wl-model-logo {
	width:240px; max-height:100%;
	display:inline-flex; align-items:center;
	overflow:hidden;
}
.wl-model-logo-img {
	width:100%;
}

.wl-model-circle {
	width:calc(100% - 660px); height:66px;
	display:flex; justify-content:flex-end;
	overflow:hidden;
}
.wl-model-circle-view {
	margin-right:20px;
	display:inline-flex; align-items:center;
}
.wl-model-circle-vi-icon {
	width:56px; height:56px; margin-right:2px;
	display:inline-flex; justify-content:center; align-items:center;
	overflow:hidden;
}
.wl-model-circle-vi-ic-img {
	width:100%; height:100%;
}
.wl-model-circle-vi-icon {
	color:#ccc;
}

.wl-model-banner {
	max-width:260px; max-height:100%;
	display:inline-flex; justify-content:flex-end; align-items:center;
	overflow:hidden;
}
.wl-model-banner-img {
	width:100%;
}
}
@media only screen and (max-width: 480px) {
	.webLogo {
	display: none;
}
}
</style>



// WEBPACK FOOTER //
// src/components/webLogo.vue